import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  const width = props.width || 34;
  const height = props.height || 34;
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 34 34`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={17} cy={17} r={16.25} fill="#2195F2" />
      <Path
        d="M15.505 18.496c-1.672-1.672-2.05-3.344-2.135-4.014a.6.6 0 01.173-.503l1.353-1.352a.604.604 0 00.085-.748l-2.154-3.345a.604.604 0 00-.783-.22L8.585 9.941a.6.6 0 00-.332.6c.181 1.722.932 5.954 5.091 10.114 4.16 4.159 8.39 4.91 10.113 5.09a.6.6 0 00.6-.332l1.63-3.459a.604.604 0 00-.22-.78l-3.345-2.155a.604.604 0 00-.748.085l-1.352 1.353a.6.6 0 01-.503.173c-.67-.086-2.342-.463-4.014-2.135z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
